import { Link } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import { Button, ForbiddenState } from '@/ui';
import styles from './Forbidden.module.css';

/**
 * A real 403.
 *
 * The legacy app never registered admin routes for non-admins, so following a shared
 * link just landed on the dashboard with no explanation.
 */
export function Forbidden() {
  const { user } = useAuth();

  return (
    <div className={styles.container}>
      <ForbiddenState
        message={
          user === null
            ? 'You do not have permission to view this page.'
            : `Your account has the "${user.role}" role, which cannot view this page. Ask an administrator if you need access.`
        }
      />
      <div className={styles.action}>
        <Link to="/">
          <Button variant="secondary">Back to dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
